export const SIDEBAR_WIDTH_SMALL = 129;
export const SIDEBAR_WIDTH_LARGE = 229;
export const BOTTOM_BAR_HEIGHT = 56;
export const SCROLL_TO_TOP_BUTTON_HEIGHT = 37;
